import { Paperclip, Upload } from 'lucide-react'
import { Link } from 'react-router'
import useSWR from 'swr'

import { Button } from '@/components/ui/button'
import { apiFetcher } from '@/data/fetcher'
import { SimpleExpense } from '@/interfaces/Expense'
import { API_URL } from '@/lib/api'

import { formatShortDate } from './documentUtils'

/** Schránka nahraných dokladů, které ještě nejsou zpracované jako náklad (Midday inbox). */
export const ExpenseInbox = ({ year, month }: { year: string; month: string | null }) => {
  const { data } = useSWR<SimpleExpense[]>(
    `/api/v2/simple-expenses?year=${year}${month ? `&month=${month}` : ''}`,
    apiFetcher,
  )
  const items = data ?? []

  return (
    <div className="mb-6 overflow-hidden rounded-lg border">
      <div className="flex items-center justify-between gap-3 border-b px-4 py-3">
        <div>
          <p className="text-sm font-medium">Schránka dokladů</p>
          <p className="text-xs text-muted-foreground">
            {items.length ? `${items.length} nahraných dokladů čeká na zpracování` : 'Nahrajte PDF nebo fotku účtenky, údaje vyplníme za vás.'}
          </p>
        </div>
        <Button variant="outline" asChild>
          <Link to="/expense/upload">
            <Upload />
            Nahrát doklad
          </Link>
        </Button>
      </div>
      {items.length > 0 && (
        <ul className="divide-y">
          {items.slice(0, 5).map((e) => (
            <li key={e.id} className="flex items-center justify-between gap-4 px-4 py-2.5 text-sm">
              <span className="w-24 shrink-0 text-muted-foreground tabular">{formatShortDate(e.receivedAt)}</span>
              <span className="min-w-0 flex-1 truncate">{e.description || 'Bez popisu'}</span>
              <span className="flex shrink-0 gap-3">
                {e.attachments.map((a) => (
                  <a key={a.id} href={`${API_URL}/api/v2/simple-expenses/${e.id}/attachments/${a.id}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-link hover:underline">
                    <Paperclip className="size-3.5" />
                    {a.filename}
                  </a>
                ))}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
